// polyfill
import "core-js/stable";
import "regenerator-runtime/runtime";

import "isomorphic-fetch";

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/scss/format.scss";
import "@/assets/main.styl";
import { createProvider } from "./vue-apollo";

// vue-js-modal
import VModal from "vue-js-modal";
Vue.use(VModal, { componentName: "vue-modal" });

// development
if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test") {
  require("dotenv").config();
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
